export default "__VITE_ASSET__BSSmLr7r__"